<div class="json-viewer">
  <button *ngIf="copyable && json" type="button" nz-button nzSize="small" class="copy-button" (click)="copy()" aria-label="Copy JSON">
    <svg-icon class="gap-icon" src="assets/icons/duplicate.svg" aria-hidden="true"></svg-icon>
    Copy
  </button>
  <p class="plain-notice" *ngIf="plain">
    {{ size }} of JSON, shown without colours to stay quick.
    <button type="button" nz-button nzType="link" nzSize="small" (click)="colourAnyway()">Colour it anyway</button>
  </p>
  <pre *ngIf="plain; else coloured">{{ json }}</pre>
  <ng-template #coloured><pre [innerHTML]="html"></pre></ng-template>
</div>
